import { useEffect, useState } from "react";
import axios from "axios";
import { IMAGES } from "../../lib/data";
import { Reveal, Overline } from "./Reveal";
import { Star, Quote } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Testimonials = () => {
  const [reviews, setReviews] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/reviews/public`)
      .then(({ data }) => setReviews(data))
      .catch(() => setReviews([]))
      .finally(() => setLoaded(true));
  }, []);

  // Hide the section entirely until there are real reviews to show.
  if (!loaded || reviews.length === 0) return null;

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="py-24 md:py-36 bg-charcoal text-sand relative overflow-hidden"
    >
      <img src={IMAGES.fieldGolden} alt="" className="absolute inset-0 w-full h-full object-cover opacity-10" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <Overline className="text-clay">What clients say</Overline>
          <h2 className="mt-5 font-heading text-4xl md:text-5xl font-light tracking-tight leading-tight max-w-2xl">
            Kind words from the riders and horses I've worked with
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.slice(0, 6).map((r, i) => (
            <Reveal key={i} delay={(i % 3) * 0.1}>
              <div
                data-testid={`review-card-${i}`}
                className="h-full bg-sand/5 backdrop-blur-sm rounded-3xl p-8 border border-sand/10 flex flex-col"
              >
                <div className="flex items-center gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <Star key={n} size={16} strokeWidth={1.5} className={r.rating >= n ? "text-clay fill-clay" : "text-sand/20"} />
                  ))}
                </div>
                <Quote className="text-clay" strokeWidth={1.5} />
                <p className="mt-3 font-heading text-xl md:text-2xl font-light leading-relaxed text-sand/90 flex-1">
                  "{r.comment}"
                </p>
                <div className="mt-6 pt-5 border-t border-sand/10">
                  <p className="font-medium text-sand">{r.name}</p>
                  {r.horse_name ? <p className="text-sm text-sand/50">with {r.horse_name}</p> : null}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
